module.exports = __webpack_public_path__ + "static/media/weningsih.f5f1d9dd.png";